import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm a{" "}
              <b className="purple">Full-Stack Software Engineer</b> and a
              2025 graduate of <b className="purple">ESPRIM</b>, specializing
              in RESTful API design, secure authentication, and relational
              data modeling with <b className="purple">ASP.NET Core</b> and{" "}
              <b className="purple">Spring Boot</b>, paired with modern{" "}
              <b className="purple">React</b> and{" "}
              <b className="purple">Angular</b> frontends.
              <br />
              <br />
              For my end-of-studies internship (PFE) at{" "}
              <b className="purple">IT Solution</b> (2025), I delivered{" "}
              <i>
                <b className="purple">ReelState</b>
              </i>
              , a full-stack social real-estate platform with short-form
              video listings. It runs on a{" "}
              <b className="purple">.NET 9 Web API</b> built with{" "}
              <b className="purple">Clean Architecture</b>,{" "}
              <b className="purple">Entity Framework Core</b>,{" "}
              <b className="purple">SQL Server</b>, and{" "}
              <b className="purple">JWT / OAuth 2.0</b> authentication, with
              real-time notifications through{" "}
              <b className="purple">SignalR</b>, an AI-powered property
              search using <b className="purple">RAG with Google Gemini</b>,
              and a <b className="purple">React + TypeScript</b> frontend.
              <br />
              <br />
              Before that, I built three{" "}
              <b className="purple">Spring Boot / Angular</b> systems,
              including an AI car-recommendation app that uses the{" "}
              <b className="purple">OpenAI API</b> for image analysis. I
              care about <b className="purple">OOP, SOLID</b>, and automated
              testing across unit, integration, and E2E levels (
              <b className="purple">xUnit, Jest, Playwright</b>).
            </p>
            <p className="home-about-body">
              My databases include{" "}
              <b className="purple">SQL Server, PostgreSQL, MySQL,</b> and{" "}
              <b className="purple">MongoDB</b>. I containerize with{" "}
              <b className="purple">Docker</b>, automate builds with{" "}
              <b className="purple">GitHub Actions CI/CD</b>, and I'm{" "}
              <b className="purple">Azure Fundamentals (AZ-900)</b>{" "}
              certified. I'm fluent in English, French, and Arabic.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;